export default "__VITE_ASSET__ByJucgDh__"